import { List, Typography } from "@mui/material";

import LoadingIndicator from "../../Common/LoadingIndicator/LoadingIndicator";

import EntityAssociationsListItem from "./EntityAssociationsListItem";
import EntityAssociationsTableHeader from "./EntityAssociationsTableHeader";

export default function EntityAssociationsTable({ data, isLoading }) {
  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!data || data.length === 0) {
    return <Typography className="text-center">No entities</Typography>;
  }

  return (
    <div className="absolute bottom-0 top-0 flex w-full flex-col overflow-y-auto px-2 [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]">
      <EntityAssociationsTableHeader />
      <List className="flex h-full flex-col gap-4" disablePadding>
        {data.map((entity) => (
          <EntityAssociationsListItem key={entity.id} data={entity} />
        ))}
      </List>
    </div>
  );
}
